import { Link } from 'react-router-dom';

import { FOCO_VISIVEL } from 'utils/foco';

import { CartaoDeExperiencia as Cartao } from '../catalogo-modelo';
import CartaoDeExperiencia from './CartaoDeExperiencia';

interface QuadroDaEscolhaProps {
  cartao: Cartao;
  virado: boolean;
  onVirar: (id?: string) => void;
  onPromocoesLivelo: () => void;
}

/**
 * A experiência resgatada no ciclo, acima da lista: o cartão dela, com o selo e só as regras, e o
 * caminho para a página da experiência (VTR-02, VTR-03, VTR-05).
 */
export default function QuadroDaEscolha({ cartao, virado, onVirar, onPromocoesLivelo }: QuadroDaEscolhaProps) {
  return (
    <section aria-labelledby="titulo-quadro-da-escolha" className="mb-8">
      <div className="mb-[18px] flex flex-wrap items-center justify-between gap-4">
        <h2 id="titulo-quadro-da-escolha" className="m-0 font-display text-[19px] font-bold leading-[normal] text-brand-blue-dark">
          Sua escolha
        </h2>
        <Link
          to="/catalogo-de-experiencias-list/feedback"
          className={`shrink-0 rounded-md bg-brand-yellow px-5 py-[11px] font-text text-[12px] font-bold uppercase tracking-[0.04em] text-brand-blue-dark no-underline transition-colors hover:bg-button-primary-hover hover:text-brand-blue-dark hover:no-underline ${FOCO_VISIVEL}`}
        >
          Ver minha experiência
        </Link>
      </div>
      {/* A mesma coluna da grade abaixo, para o cartão ter a largura dos outros. */}
      <div className="grid grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-[22px]">
        <CartaoDeExperiencia
          cartao={cartao}
          virado={virado}
          onVirar={() => onVirar(cartao.id)}
          onDesvirar={() => onVirar(undefined)}
          onConfirmar={() => undefined}
          onPromocoesLivelo={onPromocoesLivelo}
          escolhido
        />
      </div>
    </section>
  );
}
